import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import HomeIcon from '@mui/icons-material/Home';
import SearchIcon from '@mui/icons-material/Search';
import {
  Box,
  CircularProgress,
  Divider,
  Link,
  Typography,
} from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import logo2 from '../../assets/Img/logodti.svg';

interface Props {
  logout: () => void;
}

const Menus: React.FC<Props> = ({ logout }) => {
  const profileId = useSelector((state: any) => state.auth.profileId);
  const [loggingOut, setLoggingOut] = useState(false);

  const menuItemStyles = {
    margin: '4px 8px',
    borderRadius: '12px',
    minHeight: '52px',
    textDecoration: 'none',
    background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
    border: '1px solid rgba(148, 163, 184, 0.1)',
    position: 'relative',
    overflow: 'hidden',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',

    // Shimmer effect
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background:
        'linear-gradient(45deg, transparent 30%, rgba(102, 126, 234, 0.05) 50%, transparent 70%)',
      transform: 'translateX(-100%)',
      transition: 'transform 0.6s ease',
      zIndex: 1,
    },

    '&:hover': {
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      transform: 'translateY(-2px)',
      border: '1px solid rgba(255, 255, 255, 0.2)',

      '& .MuiTypography-root': {
        color: '#ffffff',
      },

      '& .MuiSvgIcon-root': {
        color: '#ffffff',
        transform: 'scale(1.1)',
      },
    },

    '&:hover::before': {
      transform: 'translateX(100%)',
    },

    '&:active': {
      transform: 'translateY(-1px)',
      transition: 'all 0.1s cubic-bezier(0.4, 0, 0.2, 1)',
    },
  };

  const logoutMenuItemStyles = {
    ...menuItemStyles,
    background: 'linear-gradient(135deg, #fef2f2 0%, #fecaca 100%)',
    border: '1px solid rgba(220, 38, 38, 0.1)',

    '&:hover': {
      background: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
      transform: 'translateY(-2px)',
      boxShadow: `
        0 4px 8px rgba(220, 38, 38, 0.15),
        0 8px 16px rgba(220, 38, 38, 0.12),
        0 16px 24px rgba(220, 38, 38, 0.08)
      `,
      border: '1px solid rgba(255, 255, 255, 0.2)',

      '& .MuiTypography-root': {
        color: '#ffffff',
      },

      '& .MuiSvgIcon-root': {
        color: '#ffffff',
        transform: 'scale(1.1)',
      },
    },
  };

  const handleLogout = () => {
    if (loggingOut) return; // evita cliques múltiplos
    setLoggingOut(true);
    logout();
  };

  return (
    <Box
      sx={{
        padding: '8px',
        minWidth: '340px',
        p: 2.5,
      }}
    >
      {profileId === 2 && (
        <Box>
          <Box sx={{ display: 'flex', justifyContent: 'center', pb: 2.5 }}>
            <img
              style={{ width: '100%', maxWidth: '200px' }}
              src={logo2}
              alt="Logo"
            />
          </Box>
          <MenuItem component={Link} href="/home-user" sx={menuItemStyles}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                position: 'relative',
                zIndex: 2,
                width: '100%',
                padding: '8px 4px',
              }}
            >
              <HomeIcon
                sx={{
                  fontSize: '22px',
                  color: '#667eea',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                }}
              />
              <Typography
                sx={{
                  fontFamily: 'Roboto-Bold',
                  fontSize: '11pt',
                  letterSpacing: '0.5px',
                  textTransform: 'uppercase',
                  color: '#374151',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                }}
              >
                Home
              </Typography>
            </Box>
          </MenuItem>

          {/* <MenuItem
            component={Link}
            href="/visualizar-eventos"
            sx={menuItemStyles}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                position: 'relative',
                zIndex: 2,
                width: '100%',
                padding: '8px 4px',
              }}
            >
              <ArticleIcon
                sx={{
                  fontSize: '22px',
                  color: '#10b981',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                }}
              />
              <Typography
                sx={{
                  fontFamily: 'Roboto-Bold',
                  fontSize: '11pt',
                  letterSpacing: '0.5px',
                  textTransform: 'uppercase',
                  color: '#374151',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                }}
              >
                EVENTOS
              </Typography>
            </Box>
          </MenuItem> */}

          <MenuItem component={Link} href="/viewer/2" sx={menuItemStyles}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                position: 'relative',
                zIndex: 2,
                width: '100%',
                padding: '8px 4px',
              }}
            >
              <SearchIcon
                sx={{
                  fontSize: '22px',
                  color: '#f59e0b',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                }}
              />
              <Typography
                sx={{
                  fontFamily: 'Roboto-Bold',
                  fontSize: '11pt',
                  letterSpacing: '0.5px',
                  textTransform: 'uppercase',
                  color: '#374151',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                }}
              >
                Visualizar
              </Typography>
            </Box>
          </MenuItem>
          <Divider
            sx={{
              margin: '12px 16px',
              background:
                'linear-gradient(90deg, transparent 0%, rgba(148, 163, 184, 0.3) 50%, transparent 100%)',
              height: '1px',
              border: 'none',
            }}
          />
        </Box>
      )}

      <MenuItem
        onClick={handleLogout}
        disabled={loggingOut}
        sx={logoutMenuItemStyles}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
            position: 'relative',
            zIndex: 2,
            width: '100%',
            padding: '8px 4px',
          }}
        >
          {loggingOut ? (
            <CircularProgress size={22} sx={{ color: '#dc2626' }} />
          ) : (
            <ExitToAppIcon
              sx={{
                fontSize: '22px',
                color: '#dc2626',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              }}
            />
          )}
          <Typography
            sx={{
              fontFamily: 'Roboto-Bold',
              fontSize: '11pt',
              letterSpacing: '0.5px',
              textTransform: 'uppercase',
              color: loggingOut ? '#9ca3af' : '#374151',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            }}
          >
            {loggingOut ? 'Saindo...' : 'Sair'}
          </Typography>
        </Box>
      </MenuItem>
    </Box>
  );
};

export default Menus;
